import React from 'react';
import styles from './index.less';
import classNames from 'classnames/bind';
import FormItemDescriptions from "#components/DescriptionsFormItem";
import { useDemandOptions } from "@mpc/common/src/features/useDemandOptions";

const cx = classNames.bind(styles);

const NoStructuredCooperation = ({
  fieldConfig,
}) => {
  const { optionsListMap } = useDemandOptions({
    keys: ['superior_resources'],
  });

  return (
    <FormItemDescriptions
      lightBorder
      className={cx('collapse-content-table')}
      column={2}
      items={[
        {
          ...fieldConfig('superior_resource_ships'),
          label: '合作平台',
          required: false,
          componentClass: "select",
          span: 2,
          elementProps: {
            options: optionsListMap?.superior_resources?.[0]?.children,
            multiple: true,
            showReset: true,
            showConfirm: true,
            selectFormat: {
              optionsToValue: (value, options) => {
                const option = options?.find((item) => item.value === value) || {};
                return {
                  ...option,
                  superior_resource_id: option?.value,
                };
              },
              valueToSelectKey: (value) => {
                return value?.value || value?.superior_resource_id;
              },
            },
          }
        },
        {
          ...fieldConfig('account'),
          formItemKey: 'account',
          label: '合作内容',
          required: true,
          componentClass: "textarea",
          span: 2,
          elementProps: {
            maxLength: 500,
          }
        },
        {
          ...fieldConfig('remark'),
          formItemKey: 'remark',
          label: '备注',
          required: false,
          componentClass: "textarea",
          span: 2,
          elementProps: {
            maxLength: 500,
          }
        }
      ]}
    />
  )
}

export default NoStructuredCooperation
